<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-08-06 15:34:53
 * @LastEditTime: 2021-10-28 13:54:48
 * @LastEditors: chenguobiao
-->
<template>
  <div class="give-up flex justify-end items-center">
    <div class="give-up__button" @click="handleGiveUp">{{replay ? '结束复盘' : '放弃考试'}}</div>
  </div>
</template>

<script>
import { GIVE_UP } from '@/config/const'
export default {
  data() {
    return {
      replay: false
    }
  },
  mounted() {
    // this.replay = store.get(WS_GAME_CONFIGS).replay
    this.replay = !!this.$route.query.testLogUid
  },
  methods: {
    handleGiveUp() {
      this.$confirm(this.replay ? '是否确定结束复盘？' : '此操作将提前提交试卷，并结束考试，是否确认结束考试？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          if (this.replay) {
            this.$router.replace('/home')
          } else {
            this.$bus.emit(GIVE_UP)
          }
        })
    }
  },
}
</script>

<style lang="scss" scoped>
  .give-up {
    &__button {
      cursor: pointer;
      margin-right: val(178);
      font-size: val(20);
      font-weight: 500;
      text-decoration: underline;
      color: #DCAD81;
    }
  }

</style>
